document.addEventListener("DOMContentLoaded", function() {

    (function () {
        let copyBtn = document.querySelector('.JS-copy-link');

        if(typeof(copyBtn) === 'undefined' || copyBtn === null)
            return;


        copyBtn.addEventListener('click', () => {
            const URL = window.location.href;
            let alertEl = document.createElement('div');
            alertEl.classList.add('webNotification');

            navigator.clipboard.writeText(URL)
                .then(() => {
                    alertEl.innerText = "Odkaz na nabídku byl zkopírován do schránky.";
                    alertEl.classList.add('webNotification-success');
                })
                .catch(() => {
                    alertEl.innerText = "Uložení odkazu na nabídku do schránky se nezdařilo.";
                    alertEl.classList.add('webNotification-error');
                });

            setTimeout(() => {
                document.body.appendChild(alertEl);
            }, 500);

            setTimeout(() => {
                alertEl.classList.add('disabled');
                alertEl.remove();
            }, 5000);
        });
    }());
});